import { Link } from 'gatsby'
import React from 'react'

const Footer = ({ author, title }) => (
  <div className="footer-area">
    <footer className="ts-footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="ts-footer-social text-center mb-30">
              <ul>
                <li>
                  <a href="https://twitter.com/srenext" target="_blank">
                    <i className="fa fa-twitter" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://join.slack.com/t/srelounge/shared_invite/enQtNTEwNjMxODEzOTQzLTViZTY5YWU1OTQ3OGU5OTkwZjc0NDAyMThlNTYyZGJlN2MyNDJjM2MwODU0NjI3YTUyN2UwMGM1MDA2MDIyNmM"
                    target="_blank"
                  >
                    <i className="fa fa-slack" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-menu text-center mb-25">
              <ul>
                <li>
                  <Link to="/#about">About</Link>
                </li>
                <li>
                  <Link to="/speakers">Speakers</Link>
                </li>
                <li>
                  <Link to="/schedule">Schedule</Link>
                </li>
                <li>
                  <Link to="/videos">Videos</Link>
                </li>
                <li>
                  <Link to="/#sponsors">Sponsors</Link>
                </li>
                <li>
                  <Link to="/#venue">Venue</Link>
                </li>
                <li>
                  <Link to="/#coc">Code of Conduct</Link>
                </li>
                <li>
                  <Link to="/#team">Team</Link>
                </li>
                <li>
                  <a href="https://blog.sre-next.dev/">Blog</a>
                </li>
              </ul>
            </div>
            <div className="copyright-text text-center">
              <p>Copyright © 2019 SRE NEXT Team</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div className="BackTo">
      <a href="#" className="fa fa-angle-up" aria-hidden="true" />
    </div>
  </div>
)

export default Footer
